// extracted by mini-css-extract-plugin
module.exports = {"filledHeader":"styles_filledHeader__SVgZf","closeIcon":"styles_closeIcon__10XS1"};